import { useState } from "react";
import Dashboard from "@/pages/Dashboard";
import Bets from "@/pages/Bets";
import PinnedCompetitions from "@/components/PinnedCompetitions";

export default function Home() {
  const [tab, setTab] = useState("overview");
  return (
    <div className="space-y-6" data-testid="home-page">
      <PinnedCompetitions />
      <div className="flex gap-1 bg-secondary/60 rounded-full p-1 w-fit">
        {[
          { id: "overview", label: "Overview" },
          { id: "bets", label: "My Bets" },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            data-testid={`home-tab-${t.id}`}
            className={
              "px-4 py-1.5 rounded-full text-sm font-medium transition-colors " +
              (tab === t.id ? "bg-card text-foreground shadow-sm" : "text-muted-foreground")
            }
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "overview" ? <Dashboard /> : <Bets />}
    </div>
  );
}
